import { useEffect, useState } from "react";
import { Dropdown } from "@/atoms-react/dropdown/index.react";
import { usei18n } from "@/features/utils/hooks/use-i18n";

export const CivilState = ({
  setResponseCivilState,
  civilStateResponse
}: {
  setResponseCivilState: (civil_state: string) => void;
  civilStateResponse?: string | null;
}) => {
  const [cs, setCs] = useState<string | undefined>();
  const { getLanguage } = usei18n();

  useEffect(() => {
    const initKey = civilStates.find((cs) => {
      return cs.value === civilStateResponse || cs.valueEn === civilStateResponse;
    });
    setCs(initKey?.key);
  }, [civilStateResponse]);

  const civilStates = [
    {
      key: "1",
      value: "Célibataire",
      valueEn: "Single"
    },
    {
      key: "2",
      value: "Marié(e)",
      valueEn: "Maried"
    },
    {
      key: "3",
      value: "Divorcé(e)",
      valueEn: "Divorced "
    },
    {
      key: "4",
      value: "Concubinage",
      valueEn: "Cohabiting"
    },
    {
      key: "5",
      value: "Veuf(ve)",
      valueEn: "Widowed"
    }
  ];
  return (
    <div className="my-4 mt-4 w-full">
      <Dropdown
        dataCy={"bronze-form-civil-state-dropdown"}
        value={cs}
        onChange={(item) => {
          if (item.value !== cs) {
            const found = civilStates.find((cs) => cs.key === item.key);
            if (!found) return;

            setResponseCivilState(found.valueEn);
            if (typeof item.value === "string") setCs(item!.value);
          }
        }}
        required={true}
        className="w-full"
        search={true}
        items={civilStates.map((cs) => {
          return {
            key: cs.key,
            value: getLanguage() === "fr" ? cs.value : cs.valueEn
          };
        })}
      />
    </div>
  );
};
